import { render } from "./InstitutionTypeWiseUserCount.vue?vue&type=template&id=3282ae9e"
import script from "./InstitutionTypeWiseUserCount.vue?vue&type=script&lang=js"
export * from "./InstitutionTypeWiseUserCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__